import { StudySubjectCategoryModel } from '@shared/models/PersonalEducationPlan';
import { StudySubjectEnumItemModel } from './ItemModels';

export enum EStudySubject {
  Science = 1,
  Technology = 2,
  Reading = 3,
  Engineering = 4,
  Art = 5,
  Math = 6,
  SocialEmotionalLearning = 7
}

export const StudySubjectEnumItems: ReadonlyArray<StudySubjectEnumItemModel> = [
  { text: 'Science', color: '#BB1209', value: EStudySubject.Science },
  { text: 'Technology', color: '#5355B6', value: EStudySubject.Technology },
  { text: 'Reading', color: '#278D16', value: EStudySubject.Reading },
  { text: 'Engineering', color: '#0F7D9B', value: EStudySubject.Engineering },
  { text: 'Art & Music', color: '#1A428A', value: EStudySubject.Art },
  { text: 'Math', color: '#60269E', value: EStudySubject.Math },
  {
    text: 'Social Emotional Learning',
    color: '#7C478D',
    value: EStudySubject.SocialEmotionalLearning
  }
];

const StudySubjectsCategoryMeta = new Map<EStudySubject, StudySubjectCategoryModel>();
StudySubjectsCategoryMeta.set(EStudySubject.Art, {
  icon: () => require('@shared/assets/Icon-ArtandMusic.svg'),
  headerBg: '39, 91, 186',
  floorBg: '69, 125, 226',
  mainBg: {
    index: () => require('@shared/assets/students/ART_BG_pattern.svg'),
    category: () => require('@shared/assets/students/art__interior.svg'),
    categoryElement: () => require('@shared/assets/students/art__table.svg')
  },
  outlineColor: '0, 0, 3',
  hero: () => require('@shared/assets/students/Homepage-Rabbit.svg'),
  heroStyle: {
    width: '380px',
    height: '448px'
  },
  innerHero: () => require('@shared/assets/students/Arts-Music-Page-Alligator.svg'),
  innerHeroStyle: {
    left: '-3%',
    width: '286px',
    height: '232px',
    bottom: 0
  }
} as StudySubjectCategoryModel);
StudySubjectsCategoryMeta.set(EStudySubject.Engineering, {
  icon: () => require('@shared/assets/Icon-Engineering.svg'),
  headerBg: '15, 125, 155',
  floorBg: '0, 178, 227',
  mainBg: {
    index: () => require('@shared/assets/students/ENGINEERING_BG_pattern.svg'),
    category: () => require('@shared/assets/students/engineering__landscape.svg'),
    categoryElement: () => require('@shared/assets/students/engineering__table.svg')
  },
  decors: [
    {
      img: require('@shared/assets/students/engineering__fence--left.svg'),
      style: { position: 'absolute', width: '165px', left: 0, bottom: '20%', 'z-index': 1 }
    },
    {
      img: require('@shared/assets/students/engineering__building.svg'),
      style: {
        position: 'absolute',
        width: '138px',
        height: '468px',
        left: 0,
        bottom: '27%',
        'z-index': 0
      }
    },
    {
      img: require('@shared/assets/students/engineering__truck.svg'),
      style: {
        position: 'absolute',
        height: '136px',
        right: 0,
        bottom: '26%',
        'z-index': 3,
        transform: 'translateX(30%)'
      }
    },
    {
      img: require('@shared/assets/students/engineering__fence--right.svg'),
      style: {
        position: 'absolute',
        height: '134px',
        right: 0,
        bottom: '27%',
        'z-index': 2,
        transform: 'translateX(35%)'
      }
    },
    {
      img: require('@shared/assets/students/engineering__crane.svg'),
      style: {
        position: 'absolute',
        height: '475px',
        width: '275px',
        right: 0,
        bottom: '29%',
        'z-index': 1
      }
    }
  ],
  outlineColor: '0, 83, 115',
  hero: () => require('@shared/assets/students/Homepage-Alien.svg'),
  heroStyle: {
    width: '200px',
    height: '448px'
  },
  innerHero: () => require('@shared/assets/students/engineering__alien.svg'),
  innerHeroStyle: {
    left: '0%',
    width: '259px',
    height: '325px',
    bottom: 0
  }
} as StudySubjectCategoryModel);
StudySubjectsCategoryMeta.set(EStudySubject.Math, {
  icon: () => require('@shared/assets/Icon-Math.svg'),
  headerBg: '131, 42, 174',
  floorBg: '171, 81, 214',
  mainBg: {
    index: () => require('@shared/assets/students/math_BG_pattern.svg'),
    category: () => require('@shared/assets/students/math__grass.svg'),
    categoryElement: () => require('@shared/assets/students/math__sandbox.svg')
  },
  outlineColor: '35, 8, 66',
  hero: () => require('@shared/assets/students/Homepage-Robot.svg'),
  heroStyle: {
    width: '270px',
    height: '447px'
  },
  innerHero: () => require('@shared/assets/students/Homepage-Rabbit.svg'),
  innerHeroStyle: {
    left: '100%',
    width: '264px',
    height: '305px',
    transform: 'translateX(-100%) rotateY(-180deg)'
  }
} as StudySubjectCategoryModel);
StudySubjectsCategoryMeta.set(EStudySubject.SocialEmotionalLearning, {
  icon: () => require('@shared/assets/Icon-SEL.svg'),
  headerBg: '112, 112, 148',
  floorBg: '148, 148, 187',
  mainBg: {
    index: () => require('@shared/assets/students/SEL_BG_pattern.svg'),
    category: () => require('@shared/assets/students/sel__interior.svg'),
    categoryElement: () => require('@shared/assets/students/sel__tables.svg')
  },
  outlineColor: '35, 8, 66',
  hero: () => require('@shared/assets/students/Homepage-Alligator.svg'),
  heroStyle: {
    width: '300px',
    height: '448px'
  },
  innerHero: () => require('@shared/assets/students/sel__robot.svg'),
  innerHeroStyle: {
    right: '40px',
    width: '226px',
    height: '290px',
    bottom: 0
  },
  decors: [
    {
      img: require('@shared/assets/students/sel__cupboard.svg'),
      style: {
        position: 'absolute',
        width: '493px',
        right: 0,
        bottom: '20%',
        'z-index': -1,
        transform: 'translateX(25%)'
      }
    }
  ]
} as StudySubjectCategoryModel);
StudySubjectsCategoryMeta.set(EStudySubject.Reading, {
  icon: () => require('@shared/assets/Icon-Reading.svg'),
  headerBg: '39, 141, 22',
  floorBg: '63, 187, 44',
  mainBg: {
    index: () => require('@shared/assets/students/reading_bg_pattern.svg'),
    category: () => require('@shared/assets/students/reading__interior.svg'),
    categoryElement: () => require('@shared/assets/students/reading__books.svg')
  },
  outlineColor: '15, 90, 6',
  hero: () => require('@shared/assets/students/Homepage-Alligator.svg'),
  heroStyle: {
    width: '300px',
    height: '448px'
  },

  innerHero: () => require('@shared/assets/students/reading__alligator.svg'),
  innerHeroStyle: {
    right: '-20px',
    width: '305px',
    height: '290px',
    bottom: 0
  }
} as StudySubjectCategoryModel);
StudySubjectsCategoryMeta.set(EStudySubject.Science, {
  icon: () => require('@shared/assets/Icon-Science.svg'),
  headerBg: '187, 18, 9',
  floorBg: '225, 37, 27',
  mainBg: {
    index: () => require('@shared/assets/students/SCIENCE_BG_pattern.svg'),
    category: () => require('@shared/assets/students/science__wall.svg'),
    categoryElement: () => require('@shared/assets/students/science__table.svg')
  },
  outlineColor: '127, 12, 0',
  hero: () => require('@shared/assets/students/Homepage-Rabbit.svg'),
  heroStyle: {
    width: '380px',
    height: '448px'
  },
  innerHero: () => require('@shared/assets/students/science__rabbitv2.svg'),
  innerHeroStyle: {
    left: '2px',
    width: '267px',
    height: '320px',
    bottom: '18%',
    transform: 'translateX(-30%)'
  }
} as StudySubjectCategoryModel);
StudySubjectsCategoryMeta.set(EStudySubject.Technology, {
  icon: () => require('@shared/assets/Icon-Technology.svg'),
  headerBg: '83, 85, 182',
  floorBg: '123, 125, 250',
  mainBg: {
    index: () => require('@shared/assets/students/TECHNOLOGY_BG_pattern.svg'),
    category: () => require('@shared/assets/students/tech__wall.svg'),
    categoryElement: () => require('@shared/assets/students/tech__panel.svg')
  },
  outlineColor: '199, 86, 0',
  hero: () => require('@shared/assets/students/Homepage-Robot.svg'),
  heroStyle: {
    width: '270px',
    height: '447px'
  },
  innerHero: () => require('@shared/assets/students/Homepage-Alien.svg'),
  innerHeroStyle: {
    left: '5%',
    width: '169px',
    height: '380px',
    transform: 'translateX(-0%)'
  }
} as StudySubjectCategoryModel);

export { StudySubjectsCategoryMeta };
